import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ActivatedRoute, Params } from "@angular/router";
import { AreasService } from "../../master-services/area-services/areas.service";
import { UserService } from "../../master-services/User/user.service";
import { ChecklisAreatService } from "../../master-services/check-list/checklistArea.service";
import { QuestionsCheckService } from "../../master-services/questionsCheck-services/questions-check.service";
import swal from "sweetalert2";
import { error } from "console";

@Component({
  selector: "app-master-area",
  templateUrl: "./questions-check.component.html",
  styleUrls: ["./questions-check.component.scss"],
})
export class QuestionsCheckComponent implements OnInit {
  ariali: any;
  addUserForm: FormGroup;
  userSelects: any;
  users: any;

  questionsCheckForm: FormGroup;
  questions: any;
  questionsLists: any;
  constructor(
    private router: Router,
    private rutaActiva: ActivatedRoute,
    private questionsCheckService: QuestionsCheckService,
    private userService: UserService
  ) {
    this.ariali = Number(localStorage.getItem("ariali"));
    this.questionsCheckList(this.ariali);
    //users add
    const id = new FormControl("0");
    const idUser = new FormControl("", Validators.required);
    this.addUserForm = new FormGroup({
      id: id,
      idUser: idUser,
    });
    //users add

    //QuestionsCheck

    const idQuestions = new FormControl("0");
    const nameQuestions = new FormControl("", Validators.required);
    this.questionsCheckForm = new FormGroup({
      idQuestions: idQuestions,
      nameQuestions: nameQuestions,
    });

    //QuestionsCheck
  }
  ngOnInit() {}

  QuestionsCheckCreate() {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();
    this.questionsCheckService
      .createUpdate(
        Number(this.questionsCheckForm.get("idQuestions").value),
        this.questionsCheckForm.get("nameQuestions").value,
        Number(this.ariali)
      )
      .then((data) => {
        const resp: any = data;

        if (resp.success === false) {
          console.log(resp.message);
          swal({
            title: "Mensaje ",
            text: resp.message,
            type: "error",
          });
        } else {
          swal({
            title: " agregado",
            type: "success",
            text: resp.message,
          });
          this.questionsCheckList(this.ariali);
        }
      })
      .catch((error) => {
        // console.log(error);
      });
  }

  questionsCheckList(id) {
    this.questionsCheckService
      .questionsCheckList(id)
      .then((data) => {
        const rest: any = data;
        this.questionsLists = rest.data;

        console.log(this.questionsLists);
      })
      .catch((error) => console.log(error));
  }

  deleteList(id) {
    swal({
      title: "Validando información ...",
      allowOutsideClick: false,
    });
    swal.showLoading();

    this.questionsCheckService.questionSetState(id).then((data) => {
      const rest: any = data;
      if (rest.success === false) {
        swal({
          title: "Mensaje ",
          text: rest.message,
          type: "error",
        });
      } else {
        swal({
          title: "Tercero agregado",
          type: "success",
        });
        this.questionsCheckList(this.ariali);
      }
    });
  }

  update(id) {
    this.questionsCheckService.questionById(id).then((data) => {
      const reast: any = data;
      this.questionsCheckForm.get("idQuestions").setValue(reast.data[0].id);
      this.questionsCheckForm
        .get("nameQuestions")
        .setValue(reast.data[0].name_questions);
    });
  }

  getIndex() {
    this.questionsCheckService
      .getIndex()
      .then((data) => {
        const rest: any = data;
        this.questionsLists = rest.data;
        this.questionsCheckList(this.ariali);

        console.log(this.questionsLists);
      })
      .catch((error) => console.log(error));
  }
}



// WEBPACK FOOTER //
// ./src/app/master/questions-check/questions-check.component.ts